import { render, staticRenderFns } from "./AddClientForm.vue?vue&type=template&id=4bb17d2e&"
import script from "./AddClientForm.vue?vue&type=script&lang=js&"
export * from "./AddClientForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports